// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"4918d5c4","353":"228248e1","405":"78e5332b","615":"eae48930","769":"cbadf31b","796":"ef9d73f9","912":"a4e28149"}[chunkId] + ".chunk.js";
};